"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExpiringContractsTier = exports.ExpiringContractsTier = void 0;
const root_1 = require("../root");
var ExpiringContractsTier;
(function (ExpiringContractsTier) {
    ExpiringContractsTier["Disabled"] = "Disabled";
    ExpiringContractsTier["Light"] = "Light";
    ExpiringContractsTier["Start"] = "Start";
})(ExpiringContractsTier = exports.ExpiringContractsTier || (exports.ExpiringContractsTier = {}));
function getExpiringContractsTier(featureFlags) {
    if (featureFlags.includes(root_1.FeatureFlag.AnalyticsExpiringContracts))
        return ExpiringContractsTier.Start;
    if (featureFlags.includes(root_1.FeatureFlag.AnalyticsExpiringContractsLight))
        return ExpiringContractsTier.Light;
    return ExpiringContractsTier.Disabled;
}
exports.getExpiringContractsTier = getExpiringContractsTier;
